import { type ClassFormAdvancedProps } from './Sections/Advanced';
import {
    type ClassLevelOptions,
    ClassLevelOverrideOptions,
    type ClassOptionsOverrides,
    type OverridableClassOptions,
    type SchoolLevelOptions
} from '../../types/adminConfig';

interface ShowSettingsProps {
    overrides?: ClassOptionsOverrides;
    overrideName: keyof ClassOptionsOverrides;
    parentPage: ClassFormAdvancedProps['parentPage'];
}

export const showSettings = ({ overrideName, overrides, parentPage }: ShowSettingsProps) => {
    const orgOverride = overrides?.[overrideName];

    if (!orgOverride) {
        return false;
    }

    if (parentPage === 'admin') {
        return orgOverride !== ClassLevelOverrideOptions.NoOne;
    }

    return orgOverride === ClassLevelOverrideOptions.AdminsAndInstructors;
};

interface ReturnClassOptionsProps {
    formClassOptions: Partial<ClassLevelOptions>;
    orgOptions: Partial<SchoolLevelOptions>;
    originalClassOptions?: Partial<OverridableClassOptions>;
}

export const returnClassOptions = ({
    formClassOptions = {},
    orgOptions = {},
    originalClassOptions = {}
}: ReturnClassOptionsProps) => {
    const classOptions = {};

    // Set recordingInitialPermission to undefined since it shouldn't be saved to school settings in RDS.
    // This is because it is managed by the RMS.
    orgOptions['recordingInitialPermission'] = undefined;

    Object.keys(formClassOptions).forEach((key) => {
        if (typeof originalClassOptions[key] !== 'undefined') {
            // Is a setting already defined at the class level?
            // Then continue to use whatever is in the form
            classOptions[key] = formClassOptions[key];

            return;
        }

        if (formClassOptions[key] !== orgOptions[key]) {
            classOptions[key] = formClassOptions[key];
        }
    });

    return classOptions;
};
